import { PrimeIcons } from "primereact/api";
import { Button } from "primereact/button";
import { FormState } from "react-hook-form";

import {
  buttonSaveUpdate,
  formUpdateAnagrafica,
  labelPendingUpdate,
} from "_constants";

export const SaveNewAnagraficaToast = ({
  formState,
}: {
  formState: FormState<{
    name: string;
    lastName: string;
    email: string;
  }>;
}) => {
  return (
    <div className="update-anagrafica-toast flex-container justify-between align-center align-selft-center profile-container-item">
      <span className="font-weight-700">{labelPendingUpdate}</span>
      <Button
        icon={PrimeIcons.SAVE}
        label={buttonSaveUpdate}
        type="submit"
        form={formUpdateAnagrafica}
        disabled={!formState.isValid}
      />
    </div>
  );
};
